var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 0.333313C7.78325 0.333313 0.333252 7.78331 0.333252 17C0.333252 26.2167 7.78325 33.6667 16.9999 33.6667C26.2166 33.6667 33.6666 26.2167 33.6666 17C33.6666 7.78331 26.2166 0.333313 16.9999 0.333313ZM24.1666 24.1666C23.5166 24.8167 22.4666 24.8167 21.8166 24.1666L16.9999 19.35L12.1833 24.1666C11.5333 24.8167 10.4833 24.8167 9.83325 24.1666C9.18325 23.5166 9.18325 22.4667 9.83325 21.8167L14.6499 17L9.83325 12.1833C9.18325 11.5333 9.18325 10.4833 9.83325 9.83331C10.4833 9.18331 11.5333 9.18331 12.1833 9.83331L16.9999 14.65L21.8166 9.83331C22.4666 9.18331 23.5166 9.18331 24.1666 9.83331C24.8166 10.4833 24.8166 11.5333 24.1666 12.1833L19.3499 17L24.1666 21.8167C24.7999 22.45 24.7999 23.5166 24.1666 24.1666Z",
    fill: "#E9E9EF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.5596914b.svg";
export { ForwardRef as ReactComponent };